import * as React from "react";
import TextField from "@mui/material/TextField";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { IconButton, Box } from "@mui/material";
import styled from "styled-components";

export default function QuantityInput({ qty = 1, handleQty = () => {}, skuID = "", variantType = "" }) {
  const [currQty, setCurrQty] = React.useState(qty);

  const updateQty = (newValue) => {
    if (newValue >= 1 && newValue <= 99) {
      setCurrQty(newValue);
      handleQty({ skuID, variantType, newValue });
    }
  };

  const TextInput = styled.input`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  
  background-color:transparent;
  border: 1px solid #ccc;
  border-radius: 4px; 
 color: #333;
  font-size: 16px;
  font-family: 'Ancizar Sans', sans-serif;
  width: 30px;
  outline: none;
  padding: 0.35rem;
  
  
  `

  return (
    <Box display="flex" alignItems="center">
      <IconButton onClick={() => updateQty(currQty - 1)} disabled={currQty <= 1}>
        <RemoveIcon />
      </IconButton>
      {/* <TextField
        type="number"
        value={currQty}
        onChange={(e) => updateQty(Number(e.target.value))}
        inputProps={{ min: 1, max: 99, style: { textAlign: "center", width: "50px" } }}
      /> */}
      <TextInput value={currQty} onChange={(e) => updateQty(Number(e.target.value))} min="1" max="99" >

      </TextInput>
      <IconButton onClick={() => updateQty(currQty + 1)} disabled={currQty >= 99}>
        <AddIcon />
      </IconButton>
    </Box>
  );
}
